
export class QuestionDto {

      questionId;
      question;
      active;
      creationPerson;
      creationDate;
      modificationPerson;
      modificationDate;
      orderNumber;
      abbrev;
      additional;
      block;
}
